import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { InputSelected } from ".";
import { SelectedInputProps } from "./Inputs/types";
import theme from "app/Theme/Theme";
import ArrowLeftIcon from "./ArrowLeftIcon";
import ArrowRightSlider from "../Icons/ArrowSlider/ArrowRightSlider";
import normalize from "app/utils/normalize";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minHeight: 45,
  },
  icon: {
    marginRight: 20,
    justifyContent: "flex-start",
  },
  redirectArrow: {
    justifyContent: "flex-end",
  },
});

interface Props {
  icon?: string;
  testID?: string;
}

const RedirectSelectionInput = ({
  onPress = () => {},
  icon = "",
  selectedText = "",
  placeholderText = "",
  testID = "",
}: Props & SelectedInputProps) => {
  return (
    <TouchableOpacity
      testID={testID}
      style={styles.container}
      onPress={onPress}
    >
      {icon !== "" && <Text style={styles.icon}>{icon}</Text>}
      <InputSelected
        placeholderText={placeholderText}
        selectedText={selectedText}
        onPress={onPress}
      />
      <View style={styles.redirectArrow}>
        <ArrowRightSlider
          width={normalize(20)}
          height={normalize(20)}
          color={theme.colors["brand.500"]}
        />
      </View>
    </TouchableOpacity>
  );
};

export { RedirectSelectionInput };
